import React from "react";
import ContactDetails from "../components/ContactDetails";

const Admission = () => (
  <div className="mx-auto pb-8 bg-blue-theme">
    <img className="w-full h-[60dvh] object-cover mb-12" src="/assets/images/admission-bg.jpg" alt="" />
		<div className="max-w-4xl mx-auto  px-4">
        {/* Admission Header Section */}
        <header className="text-center mb-8">
          <h1 className="text-4xl font-bold text-theme">Admission Process</h1>
          <p className="text-lg sm:text-xl text-gray-300 mt-4">
            Learn about the admission criteria and the application process.
          </p>
        </header>

        {/* Admission Criteria Section */}
        <section className="mb-12 font-semibold text-theme mb-4">
          <h2 className="text-3xl mb-4">Admission Criteria</h2>
          <p className="text-lg sm:text-xl text-gray-300 mb-4">
            To apply for admission, applicants must meet the following criteria:
          </p>
          <ul className="list-disc list-inside text-gray-300 space-y-2">
            <li>Minimum 50% marks in the last qualifying examination.</li>
            <li>Valid proof of identity (Aadhar Card, Birth Certificate, etc.).</li>
          </ul>
        </section>

        {/* Admission Process Section */}
        {/* <section className="mb-12">
          <h2 className="text-3xl font-semibold text-theme mb-4">Admission Process</h2>
          <p className="text-lg sm:text-xl text-gray-300 mb-4">
            Follow these steps to successfully complete your admission application:
          </p>
          <ol className="list-decimal list-inside text-gray-300 space-y-2">
            <li>
              <span className="font-semibold">Step 1: Fill the Online Application Form</span> - Provide your personal, academic, and contact details.
            </li>
            <li>
              <span className="font-semibold">Step 2: Submit Required Documents</span> - Upload your academic certificates, ID proof, and any other necessary documents.
            </li>
            <li>
              <span className="font-semibold">Step 3: Pay the Application Fee</span> - Pay the non-refundable application fee online.
            </li>
            <li>
              <span className="font-semibold">Step 4: Entrance Exam (if applicable)</span> - For certain courses, an entrance exam is conducted. Prepare and attend the exam.
            </li>
            <li>
              <span className="font-semibold">Step 5: Interview (if applicable)</span> - Some programs may require an interview. You will be notified if this applies to you.
            </li>
            <li>
              <span className="font-semibold">Step 6: Admission Confirmation</span> - After reviewing all the applications, selected candidates will be informed via email or phone. Confirm your admission by completing the required formalities.
            </li>
          </ol>
        </section> */}

        {/* Important Dates Section */}
        {/* <section className="mb-12">
          <h2 className="text-3xl sm:text-4xl font-semibold text-theme mb-4">Important Dates</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full text-gray-300">
              <thead>
                <tr>
                  <th className="px-6 py-3 text-left">Event</th>
                  <th className="px-6 py-3 text-left">Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-6 py-3 border-t">Application Start Date</td>
                  <td className="px-6 py-3 border-t">January 1, 2024</td>
                </tr>
                <tr>
                  <td className="px-6 py-3 border-t">Application Deadline</td>
                  <td className="px-6 py-3 border-t">March 31, 2024</td>
                </tr>
                <tr>
                  <td className="px-6 py-3 border-t">Entrance Exam Date</td>
                  <td className="px-6 py-3 border-t">April 15, 2024</td>
                </tr>
                <tr>
                  <td className="px-6 py-3 border-t">Interview Date</td>
                  <td className="px-6 py-3 border-t">April 20, 2024</td>
                </tr>
                <tr>
                  <td className="px-6 py-3 border-t">Admission Confirmation</td>
                  <td className="px-6 py-3 border-t">May 5, 2024</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section> */}

        {/* Contact Info Section */}
        <section className="mb-12">
          <h2 className="text-3xl sm:text-4xl font-semibold text-theme mb-4">Contact Information</h2>
          <p className="text-lg sm:text-xl text-gray-300 mb-4">
            For any inquiries or support, please reach out to us:
          </p>
          <ContactDetails iconTheme="text-theme" headerNameTheme="font-bold text-theme" valueTheme="text-white" />
        </section>
      </div>
	</div>
);

export default Admission;
